import { Box, Text, Flex, ListItem, UnorderedList } from "@chakra-ui/react";
import { Dot } from "pages/Phoenix/Analytics/components/dot";
import { numberToDollar, stringToFullNumber } from "utils/helpers";

const pipeLineToolTip = (props: any, user: any) => {
	const { label, payload = [] } = props;

	const custom_currency =
		user?.user?.company?.company_configurations[0]?.custom_currency?.currency ||
		"$";

	return (
		<Box p={4} borderRadius={8} background={"#717579"} fontSize={14}>
			<Text fontWeight="600" color="#FFF">
				{label}
			</Text>
			<UnorderedList listStyleType="none" m="0" p="0" minWidth="300px">
				{payload.map((entry: any, index: number) => (
					<ListItem key={`pipeline-tooltip-entry-${index}`}>
						<Flex direction="column">
							{entry.payload.loanAmounts.length > 0 ? (
								<>
									{entry.payload.loanAmounts
										.sort((a: number, b: number) => b - a)
										.slice(0, 8)
										.map((loanAmount: string, loanIndex: number) => (
											<Flex
												key={`loan-amount-${loanIndex}`}
												gap={2}
												justifyContent="space-between"
											>
												<Box display="flex" alignItems="center" gap={2}>
													<Dot color={entry.color ?? "transparent"} />
													<Text color="#FFF" casing="capitalize">
														{entry.payload.loanName[loanIndex]}
													</Text>
												</Box>
												<Text color="#FFF">
													{numberToDollar(
														stringToFullNumber(loanAmount),
														custom_currency
													)}
												</Text>
											</Flex>
										))}
									{entry.payload.loanName.length > 8 && (
										<Flex justifyContent="center">
											<Text color="#FFF">
												+ {entry.payload.loanName.length - 8} more
											</Text>
										</Flex>
									)}
								</>
							) : (
								<Text color="#FFF">No loans for this type</Text>
							)}
						</Flex>
					</ListItem>
				))}
			</UnorderedList>
		</Box>
	);
};

export default pipeLineToolTip;
